export class StackToSend<T extends (...args: any[]) => Promise<any>> {
  /**
   * * Функция для отправки
   */
  private sendFunc: T;
  /**
   * * Функция для сжатия стека
   */
  private compressStack?: (stack: Array<Parameters<T>>) => Parameters<T> | undefined;
  /**
   * * Стек для отправки
   */
  private stack = new Array<Parameters<T>>();
  /**
   * * В данный момент происходит отправка
   */
  private isSending = false;
  /**
   * * В данный момент происходит отправка из стека
   */
  private isSendingStack = false;
  /**
   * * Ожидание отправки следующего запроса
   */
  private delay: number = 0;

  /**
   * * Функция для ожидания
   * @returns
   */
  private timeout = () => {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, this.delay);
    });
  };

  /**
   * * Отправить весь собранный стек
   * @returns
   */
  sendStack = async () => {
    if (this.isSendingStack || !this.stack.length) return;
    this.isSendingStack = true;
    this.isSending = true;

    if (this.compressStack) {
      const item = this.compressStack(this.stack);
      if (item) {
        this.stack = [];
        await this.sendFunc(...item).catch((e) => {
          console.error(e);
        });
        await this.timeout();
      }
    } else {
      while (this.stack.length) {
        const item = this.stack.shift();
        if (!item) break;
        await this.sendFunc(...item).catch((e) => {
          console.error(e);
        });
        await this.timeout();
      }
    }

    this.isSending = false;
    this.isSendingStack = false;
  };

  /**
   * * Отправить данные
   * @param args
   * @returns
   */
  send = async (...args: Parameters<T>): Promise<void> => {
    if (this.stack.length || this.isSending) {
      this.stack.push(args);
      return;
    }
    this.isSending = true;
    await this.sendFunc(...args)
      .catch((e: any) => {
        console.error(e);
      })
      .finally(async () => {
        await this.timeout();
        if (this.stack.length) await this.sendStack();
        else this.isSending = false;
      });
  };

  /**
   * @param func Функция для отправки
   * @param compressStack Фкнция для сжатия стека запросов в один
   * @param beforeNextSendDelay Ожидание перед следующим запросом
   */
  constructor(
    func: T,
    compressStack?: (stack: Array<Parameters<T>>) => Parameters<T> | undefined,
    beforeNextSendDelay: number = 0,
  ) {
    this.sendFunc = func;
    this.compressStack = compressStack;
    this.delay = beforeNextSendDelay;
  }
}
